import Subscribe from 'components/Subscribe';
import Button from 'components/Button';
import Footer from 'components/Footer';
import Layout from 'containers/Layout';
import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import Meta from 'utils/Meta';
import RichText from 'utils/RichText';
import { sizes, colors, helpers, media, width } from 'styles/variables';
import { log, fblog, slog } from 'utils/log';

export default props => {
	const lang = props.pageContext.lang || '';
	const [meta] = useState(require(`data/_meta`));
	const [error] = useState(props.pageContext.item);
	const [translations] = useState(require(`data/${lang}_translations`));
	const [form] = useState(
		typeof localStorage !== 'undefined' && localStorage.getItem('form')
			? JSON.parse(localStorage.getItem('form'))
			: null,
	);
	console.log(error);

	useEffect(() => {
		if (window.location.pathname.indexOf('fundamental-fiber-complex-out-of-stock') > -1) {
			log('Upsell', 'Purchased', window.location.pathname.substr(1));
			fblog('trackCustom', 'upsell_purchased');
			slog(`Purchased Upsell`, form.values.email);
		} else {
			log('ErrorPage', 'Path', window.location.pathname.substr(1));
			fblog('trackCustom', 'error_page_' + window.location.pathname.substr(1));
		}
	});

	const StyledWrapper = styled.div`
		${error.type === 'male' ? `background:#10120c` : ``};
		${helpers.fit};
		.right_image,
		.left_image {
			filter: blur(3px);
			position: fixed;
			top: -10px;
			bottom: -10px;
			height: calc(100% + 20px);
			width: auto;
			${media.small} {
				opacity: 0.2;
			}
		}
		.right_image {
			left: 50%;
			${media.small} {
				left: -10px;
			}
		}
		.left_image {
			right: 50%;
			${media.small} {
				right: -10px;
			}
		}
	`;

	const Error = styled.div`
		padding: ${sizes[2]};
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		max-width: ${width.small}px;
		${media.small} {
			width: 100%;
		}
		h1 {
			font-size: 2.5rem;
			${media.small} {
				font-size: 1.5rem;
			}
		}
		p {
			${media.notsmall} {
				padding: 0 15%;
			}
		}
		* {
			${error.type === 'male' ? `color:${colors.background[0]}` : ``};
			em {
				white-space: nowrap;
				color: ${colors.brand.base};
				${error.type === 'male' ? `color:${colors.teal.base}` : ``};
			}
		}
		a {
			display: block;
			max-width: 400px;
			margin: 0 auto;
		}
	`;

	return (
		<>
			<Meta {...props} />
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						'@context': 'http://schema.org',
						'@type': 'WebPage',
						url: meta.domain,
						name: meta.title,
						description: meta.description,
					})}
				</script>
			</Helmet>
			<Layout>
				<StyledWrapper>
					{error.right_image && (
						<img className="right_image" alt="right background" src={error.right_image.url} />
					)}
					{error.left_image && (
						<img className="left_image" alt="left background" src={error.left_image.url} />
					)}
					<Error>
						<RichText data={error.body} />
						{error.subscription_list && (
							<Subscribe
								theme={error.type === 'male' ? 'dark' : 'light'}
								group={error.slug}
								title={translations.subscribe}
							/>
						)}
						{error.button_title && (
							<a href={`/${error.button_link ? error.button_link : ''}`}>
								<br />
								<Button title={error.button_title} type={2} hue="pink" />
							</a>
						)}
					</Error>
					<Footer fixed={true} {...props} />
				</StyledWrapper>
			</Layout>
		</>
	);
};
